module.exports = __webpack_public_path__ + "static/images/group-border.37f76ef.png";